/**
 * 存钱罐业务逻辑辅助函数
 */

import type { HomeRes } from '@/types/api/gullak-cash/home';
import { GullakClaimStatus, GullakSpecialRateEnum, GullakStatus, GullakTranslateStatusEnum, MIN_CLAIMABLE_CASH } from '../constants/gullak-status';

/**
 * 判断存钱罐是否开启
 */
export function isGullakOpen(status: number | undefined): boolean {
  return status === GullakStatus.Open;
}

/**
 * 判断是否未达等级（VIP等级 < 1）
 */
export function isLevelInsufficient(vipLevel: number | undefined): boolean {
  return vipLevel !== undefined && vipLevel < 1;
}

/**
 * 判断可领取金额是否不足（< 1法币）
 */
export function isAmountInsufficient(depositCash: string | undefined): boolean {
  if (!depositCash) return false;
  return Number(depositCash) < MIN_CLAIMABLE_CASH;
}

/**
 * 判断是否已领取
 */
export function isAlreadyClaimed(isClaim: string | undefined): boolean {
  return isClaim === GullakClaimStatus.Claimed;
}

/**
 * 判断金额是否超过每日限额
 */
export function isAboveDailyLimit(depositCash: string | undefined, maxAmount: string): boolean {
  if (!depositCash) return false;
  return Number(depositCash) > Number(maxAmount);
}

/**
 * 判断是否可以领取
 * @param homeData 存钱罐主页数据
 * @param isLogin 是否登录
 * @returns 是否可以领取
 */
type IProps = Pick<HomeRes, 'vip_level' | 'deposit_cash' | 'is_claim'> | undefined;
export function canClaim(homeData: IProps, isLogin: boolean): boolean {
  if (!isLogin || !homeData) return false;

  // 未达等级不可领取
  if (isLevelInsufficient(homeData.vip_level)) return false;

  // 可领取金额不足不可领取
  if (isAmountInsufficient(homeData.deposit_cash)) return false;

  // 已领取不可领取
  if (isAlreadyClaimed(homeData.is_claim)) return false;

  return true;
}

/**
 * 计算下次可领取时间的倒计时（秒）
 * @param endTimeStamp 结束时间戳（秒）
 * @returns 倒计时秒数
 */
export function getNextClaimCountdown(endTimeStamp: number): number {
  const now = Date.now(); // 当前客户端时间戳（毫秒）

  const endTimeMs = endTimeStamp * 1000;

  // 计算时间差（毫秒）
  const diffMs = endTimeMs - now;

  // 如果时间已过期，返回 0
  if (diffMs <= 0) return 0;

  // 返回秒数
  return Math.floor(diffMs / 1000);
}

export function checkCanTranslate(status: number): boolean {
  return GullakTranslateStatusEnum.Open === status;
}

export function checkIsSpecialRate(special_status: number) {
  return GullakSpecialRateEnum.Open === special_status;
}